import { Elm } from './../ui/Recapi.elm'
import mapOptimised, {
  StorageReadySignal,
  WorkerErrorSignal,
  StorageResultSignal
} from "./signal.js"

const sqliteInitWorkerHref = new URL("./operator.mjs", import.meta.url).href
const sqliteWorker = new Worker(
  sqliteInitWorkerHref,
  { type: "module" }
)

const messageHandler = (resolve, reject, timeout) => (event) => {
  if (event.type === "error") {
    console.error('[SQLite Worker Error]:', event.message)
    clearTimeout(timeout)
    reject(new Error(event.message))
    return
  }
  const { data: { signal, payload }} = event
  switch (signal) {
    // case 'log':
    //   console.log('[SQLite Worker Log]:', message)
    //   break;

    case WorkerErrorSignal.name:
      const { message, stack } = payload
      console.error('[SQLite Worker Error]:', message)
      clearTimeout(timeout)
      reject(new Error(message, stack))
      break;

    case StorageResultSignal.name:
      // Handle storage result signals if needed
      console.log('[SQLite Worker] Storage Result:', payload)
      break;


    case StorageReadySignal.name:
      const { dbPath, sqliteVersion } = payload
      clearTimeout(timeout)
      console.log('✅ OPFS_DB is ready!')
      console.log('   Database path:', dbPath)
      console.log('   SQLite version:', sqliteVersion)

      // Make the worker globally available if needed
      window.sqliteWorker = sqliteWorker

      resolve({
        worker: sqliteWorker,
        dbPath,
        sqliteVersion
      })
      break;

    default:
      console.warn('[SQLite Worker] Unknown message signal:', signal)
  }
}

// Promise that resolves when OPFS_DB is ready
const waitForOPFS_DB = new Promise((resolve, reject) => {
  const timeout = setTimeout(() => {
    reject(new Error('SQLite initialization timeout after 30 seconds'))
  }, 30000)

  sqliteWorker.addEventListener('message', messageHandler(resolve, reject, timeout))
  sqliteWorker.addEventListener('error', messageHandler(resolve, reject, timeout))
})

// Export the promise for other modules
window.OPFS_DB_READY = waitForOPFS_DB

const dbResultHandler = (event) => {
  const { data, data: { signal, payload } } = event
  // console.log('[SQLite Worker] Storage Result:', data)
  window.recapi.ports.results.send({ payload, signal: mapOptimised(signal) })
}

 const queriesListener = (worker) => {
   return (message) => {
     console.debug('[Recapi Elm] Query:', message)
     worker.postMessage(message)
   }
 }

 const initElmApp = () => {
   window.recapi = Elm.Recapi.init({
     node: document.querySelector('main')
   })
   console.debug('Recapi Elm initialized', window.recapi)
 }

// Initialize OPFS_DB and then load other modules
waitForOPFS_DB
  .then(({ worker, dbPath, sqliteVersion }) => {
    initElmApp()
    worker.addEventListener('message', dbResultHandler)
    window.recapi.ports.queries.subscribe(queriesListener(worker))
    window.recapi.ports.results.send({
      signal: 'tasks', payload: [
        { id: "t-uuid-id-1", note: "task 1", status: 0, scopeId: 's-uuid-id-1' },
        { id: "t-uuid-id-2", note: "task 2", status: 1, scopeId: 's-uuid-id-2' }
      ]
    })
    console.log('✅ All core modules loaded')
  })
  .catch((error) => {
    console.error('❌ Failed to initialize OPFS_DB:', error)
  })
